const segmentRules = [
  {
    name: 'Has products in cart',
    key: 'hasCart',
    inverseSelection: false,
    type: 'context',
    field: 'cart.products',
    availableFilters: {
      count: {
        field: 'cart.products',
      },
    },
  },
  {
    name: 'Registered',
    key: 'registered',
    inverseSelection: false,
    type: 'context',
    field: 'profile.registeredAt',
    availableFilters: {},
  },
  {
    name: 'Subscribed',
    key: 'subscribed',
    inverseSelection: false,
    type: 'context',
    field: 'profile.subscribedAt',
    availableFilters: {},
  },
  {
    name: 'Clicked email',
    key: 'clickedEmail',
    inverseSelection: false,
    type: 'attribution',
    field: 'emailId',
    availableFilters: {
      emailId: {},
    },
  },
  {
    name: 'Clicked push notification',
    key: 'clickedPush',
    inverseSelection: false,
    type: 'attribution',
    field: 'pushNotificationId',
    availableFilters: {
      pushNotificationId: {},
    },
  },

  {
    name: 'Clicked text message',
    key: 'clickedTextMessage',
    inverseSelection: false,
    type: 'attribution',
    field: 'textMessageId',
    availableFilters: {
      textMessageId: {},
    },
  },
  {
    name: 'Clicked viber message',
    key: 'clickedViberMessage',
    inverseSelection: false,
    type: 'attribution',
    field: 'viberMessageId',
    availableFilters: {
      viberMessageId: {},
    },
  },
  {
    name: 'Clicked product block',
    key: 'clickedProductBlock',
    inverseSelection: false,
    type: 'attribution',
    field: 'recommenderId',
    availableFilters: {
      productBlock: {},
    },
  },
  {
    name: 'Clicked banner block',
    key: 'clickedBannerBlock',
    inverseSelection: false,
    type: 'attribution',
    field: 'bannerBlockId',
    availableFilters: {
      bannerBlock: {},
    },
  },
  {
    name: 'Profile Attributes',
    key: 'profileAttributes',
    inverseSelection: false,
    type: 'context',
    availableFilters: {
      group: {},
      isFirstSesssion: {},
      profileTags: {},
    },
  },
  {
    name: 'Clicked whatsapp message',
    key: 'clickedWhatsappMessage',
    inverseSelection: false,
    type: 'attribution',
    field: 'whatsappMessageId',
    availableFilters: {
      whatsappMessageId: {},
    },
  },
];

export default segmentRules;
